import { change } from 'redux-form';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import { JOURNEY_BUILDER_FORM_NAME } from '../../../constants/JourneyBuilder';
import { removePath, renamePath } from '../../../actions/JourneyBuilder';
import AddPathComponent from './AddPath';
import PathComponent, { styles as pathStyles } from './PathComponent';
import RemainingPathComponent, { pathRemainingStyles } from './RemainingPathComponent';

export const mapDispatchToProps = dispatch => ({
  renamePathDispatch(index, value) {
    dispatch(renamePath(index, value));
  },
  removePathDispatch(index) {
    dispatch(removePath(index));
  },
  setPathNameDispatch(fieldName, value) {
    dispatch(change(JOURNEY_BUILDER_FORM_NAME, fieldName, value));
  },
});

const loader = lifecycle({
  componentDidMount() {
    const {
      item: {
        arguments: { branchResult },
        metaData,
      },
      setPathNameDispatch,
    } = this.props;

    setPathNameDispatch(branchResult, metaData && metaData.label);
  },
  componentDidUpdate(prevProps) {
    const prevMetaData = prevProps.item.metaData;
    const {
      item: {
        arguments: { branchResult },
        metaData,
      },
      setPathNameDispatch,
    } = this.props;

    if (prevMetaData.label !== metaData.label) {
      setPathNameDispatch(branchResult, metaData && metaData.label);
    }
  },
});

export const PathLoader = loader(PathComponent);
export const RemainingPathLoader = loader(RemainingPathComponent);

export const Path = compose(
  connect(
    null,
    mapDispatchToProps
  ),
  withStyles(pathStyles)
)(PathLoader);

export const RemainingPath = compose(
  connect(
    null,
    mapDispatchToProps
  ),
  withStyles(pathRemainingStyles),
  injectIntl
)(RemainingPathLoader);

export const AddPath = AddPathComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/index.js